import { NeuImage } from "@neutron/react";

export function Image(props: {className?: string, width?: number, src: string, alt?: string, onClick?: () => void}) {
    return (
        <NeuImage className={props.className} width={props.width} src={props.src} alt={props.alt!} onClick={() => props.onClick?.()}></NeuImage>
    )
}